function optionUpdate() {
  const selectors = document.querySelectorAll('[checked][data-option-value-id][form]');
  console.log(selectors);
  if (selectors.length > 0) {
    const selectedVariantName = [... selectors].filter(e=>e.id.split(/-/).length === 5).map(e=>e.value).join(' / ');
    console.log(selectedVariantName);
      //selectors[0].value;
    const filteredName = selectedVariantName.replace(/ ※\d+/g, '');
    handbagDisplay(filteredName, !selectedVariantName.includes("※1"));
    wrapDisplay(filteredName, !selectedVariantName.includes("※2"));
    forceWrap(filteredName, selectedVariantName.includes("※3") || selectedVariantName.includes("※4"));
    hideWrappingPaper(filteredName, selectedVariantName.includes("※2") || (selectedVariantName.includes("※4") && !selectedVariantName.includes("※3")));
    showProductSpec(selectedVariantName);
    showVariantImage(selectedVariantName);
  }
  transformVariantLabelText();
}

const handleMutation = (mutationsList, observer) => {
  let flag = false;
  mutationsList.forEach(mutation => {
    if (mutation.type === "childList") {
      const nodes = mutation.addedNodes;
      nodes.forEach(n=>{
        if (n.nodeName === '#text' || !(n.classList?.contains('bold_help_text_disabled') || n.classList?.contains('bold_help_text_hide_nowrap'))) {
          flag = true;
        }
      });
    }
  });
  if (flag) {
    optionUpdate();
  }
};

function showVariantImage(variantTitle) {
  [...document.querySelectorAll('li:has(div.product__media img[alt*="{{"][alt*="}}"])')].forEach(e=>e.style.display='none');
  [...document.querySelectorAll('li:has(div.product__media img[alt*="{{'+variantTitle+'}}"])')].forEach(e=>e.style.display='list-item');
  [...document.querySelectorAll('li:has(button.thumbnail img[alt*="{{"][alt*="}}"])')].forEach(e=>e.style.display='none');
  [...document.querySelectorAll('li:has(button.thumbnail img[alt*="{{'+variantTitle+'}}"])')].forEach(e=>e.style.display='list-item');
}

function showProductSpec(variantTitle) {
  console.log(variantTitle);
  [...document.querySelectorAll("table[data-bzn-variant-name]")].forEach(t=>t.style.display="none");
  document.querySelectorAll(`table[data-bzn-variant-name="${variantTitle}"]`).forEach(e=>e.style.setProperty("display", "table"));
  [...document.querySelectorAll("input[data-bzn-variant-name]")].forEach(t=>t.disabled = true);
  document.querySelectorAll(`input[data-bzn-variant-name="${variantTitle}"]`).forEach(e=>e.disabled = false);
}

const form = document.querySelector('product-info');

const observer = new MutationObserver(handleMutation);

const config = { attributes: true, childList: true, subtree: true };

observer.observe(form, config);

optionUpdate();